var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbDownFilled = props => {
  const {
    size,
    color,
    svgProps
  } = props;
  props = {
    width: size || 24,
    height: size || 24,
    color: color || 'currentColor',
    ...svgProps
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3h9.5v10l-6 6-.667-.458c-.25-.18-.434-.41-.552-.688A1.338 1.338 0 017.208 17L8 13H2.5c-.417 0-.77-.146-1.063-.438A1.447 1.447 0 011 11.5v-1.188a1.347 1.347 0 01.125-.583l2.48-5.812c.11-.278.294-.5.551-.667A1.52 1.52 0 015 3zm11 10V3h3v10h-3z"
  })));
};
export default SvgThumbDownFilled;